import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { BaseManagement } from '../../services/base-management';
import { Subscription, interval } from 'rxjs';
import { DialogYesNoComponent } from '../dialog-yes-no/dialog-yes-no.component';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';

@Component({
  selector: 'prgov-two-factor-verification-modal',
  templateUrl: './two-factor-verification-modal.component.html',
  styleUrls: ['./two-factor-verification-modal.component.scss']
})
export class TwoFactorVerificationModalComponent extends BaseManagement
  implements OnInit, OnDestroy, AfterViewInit {
  twoFactorForm: FormGroup;
  loginForm: FormGroup;
  private subscription: Subscription;

  countDown = 0;
  formattedTime: string = this.formatTime(this.countDown);
  showCountDownText = false;
  validatingCode = false;
  token: any;

  constructor(
    private fb: FormBuilder,
    protected translate: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogRef: MatDialogRef<TwoFactorVerificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authService: AuthService
  ) {
    super();
    console.log(data);
    this.loginForm = this.fb.group({
      grant_type: ['password'],
      username: ['', Validators.compose([Validators.maxLength(70), Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'), Validators.required])],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.initForm();
    if (this.data) {
      this.loginForm.patchValue(this.data);
    } else {
      this.dialogRef.close();
    }
  }

  ngOnDestroy(): void {
    this.clearSubscription();
  }

  ngAfterViewInit(): void {
    this.scrollToTargetDiv();
  }

  initForm() {
    this.twoFactorForm = this.fb.group({
      VerificationCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });
  }

  scrollToTargetDiv(): void {
    const targetDiv = document.getElementById('targetDiv');
    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    }
  }

  resendCode() {
    this.clearSubscription();
    this.generateCode2FA();
  }

  formatTime(seconds: number): string {
    const minutes: number = Math.floor(seconds / 60);
    const remainingSeconds: number = seconds % 60;
    return this.padZero(minutes) + ':' + this.padZero(remainingSeconds);
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  clearSubscription() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  tryResendCode() {
    const dialogRef = this.dialog.open(DialogYesNoComponent, {
      width: '250px',
      data: {
        msg: '¿Reenviar Código de verificación?',
        yesText: 'Reenviar',
        noText: 'Cancelar',
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 1) {
        this.countDown = 10;
        this.formattedTime = this.formatTime(this.countDown);
        this.resendCode();
      }
    });
  }

  validateCode() {
    this.validatingCode = true;
    this.verify2FAToken();
  }

  async continueLogin() {
    this.dialogRef.close(true);
  }


  generateCode2FA() {
    // Genero codigo de dos factores
    this.authService.generateTwoFactor({ Email: this.loginForm.controls.username.value, Password: this.loginForm.controls.password.value }).then(async (response: any) => {
      // console.log('generateTwoFactor', response);
      this.showCountDownText = true;
      this.countDown = 10;
      const timer$ = interval(1000);

      this.subscription = timer$.subscribe(() => {
        if (this.countDown > 0) {
          this.countDown--;
          this.formattedTime = this.formatTime(this.countDown);
        } else {
          this.clearSubscription();
        }
      });
    });
  }

  openDialogError() {
    const dialogRef = this.dialog.open(DialogOkComponent, {
      data: {
        msg: 'Código invalido. Intentelo de nuevo',
      }
    });

    dialogRef.afterClosed().subscribe((res: any) => { });
  }

  verify2FAToken() {
    // Verifico el token de dos factores
    this.authService.verifyTwoFactorToken({ Email: this.loginForm.controls.username.value, Token: this.twoFactorForm.controls.VerificationCode.value })
      .then((verify: any) => {
        if (verify.Success) {
          this.continueLogin();
        } else {
          this.validatingCode = false;

          this.openDialogError();
          console.error('verifyTwoFactorToken', verify);
        }
      })
      .catch((err: any) => {
        this.openDialogError();
        this.validatingCode = false;
      });
  }

}
